/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { IonButton, IonIcon, IonModal, IonSpinner } from "@ionic/react";
import { add, closeOutline, sendOutline } from "ionicons/icons";
import FollowerListItem from "./FollowerListItem";
import EmptyState from "./EmptyState";
import { requestTitle } from "./requestTitle";

import { FollowingListProps } from "./DataSharingTypes";
import { DisplayPendingRequest } from "../PendingRequests";
import {
  acceptFollowRequest,
  rejectFollowRequest,
} from "../../../services/datashare";
import { getInitials, getUserName } from "../../../utils/helpers";

const FollowingList: React.FC<FollowingListProps> = ({
  following,
  pendingOutgoing,
  actionRequired,
  onRemoveFollowing,
  onCancelRequest,
  onInviteClick,
  isLoading,
}) => {
  const hasData = following.length > 0 || pendingOutgoing.length > 0;
  const [pendingOpen, setPendingOpen] = useState(true);
  const [popupOpen, setPopupOpen] = useState(false);
  const [actionsRequiredItems, setActionsRequiredItems] = useState<
    DisplayPendingRequest[]
  >(actionRequired || []);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  useEffect(() => {
    setActionsRequiredItems(actionRequired || []);
  }, [actionRequired]);

  const confirmAcceptRequest = async (selectedRequest?: any): Promise<void> => {
    if (!selectedRequest) return;
    setActionsRequiredItems((prev) =>
      prev.filter((req) => req.id !== selectedRequest.id),
    );
    if (selectedRequest.type === "incoming_follower_request") {
      await acceptFollowRequest({ relationship_id: selectedRequest.id });
    } else if (selectedRequest.type === "incoming_following_request") {
      await acceptFollowRequest({ relationship_id: selectedRequest.id });
    }
  };
  const confirmRejectRequest = async (selectedRequest?: any): Promise<void> => {
    if (!selectedRequest) return;
    try {
      setActionsRequiredItems((prev) =>
        prev.filter((req) => req.id !== selectedRequest.id),
      );
      await rejectFollowRequest({ relationship_id: selectedRequest.id });
    } catch (error) {
      console.error("Failed to reject request:", error);
    }
  };
  const followerRequests: DisplayPendingRequest[] = [];
  const followingRequests: DisplayPendingRequest[] = [];
  actionsRequiredItems.forEach((req) => {
    if (req.type === "incoming_follower_request") followerRequests.push(req);
    if (req.type === "incoming_following_request") followingRequests.push(req);
  });
  const pageType = "following"; // could be 'followers', 'following', or undefined for both
  let filteredRequests: DisplayPendingRequest[] = [];
  const normalizedPageType = (pageType || "").toLowerCase();
  if (normalizedPageType === "followers") {
    filteredRequests = followerRequests.filter(Boolean);
  } else if (normalizedPageType === "following") {
    filteredRequests = followingRequests.filter(Boolean);
  } else {
    // default: include both incoming follower and following requests
    filteredRequests = actionsRequiredItems.filter(
      (req) =>
        req.type === "incoming_follower_request" ||
        req.type === "incoming_following_request",
    );
  }
  if (isLoading && !hasData) {
    return (
      <div className="flex justify-center items-center py-12">
        <IonSpinner name="crescent" color="primary" />
      </div>
    );
  }

  return (
    <>
      {" "}
      <div
        className=""
        style={{
          // position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <>
          {popupOpen && (
            <IonModal
              isOpen={popupOpen}
              onDidDismiss={() => setPopupOpen(false)}
              presentingElement={document.querySelector("ion-app") || undefined}
              canDismiss={true}
              showBackdrop={true}
              backdropDismiss={true}
              style={{
                "--background": "transparent",
                "--box-shadow": "none",
                "--border-radius": "20px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  borderRadius: "20px",
                  maxHeight: "70vh",
                  overflow: "hidden",
                  margin: "20px",
                }}
              >
                {/* Header with close button and title */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "3px",
                  }}
                >
                  <div style={{ width: "40px" }}></div>
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      margin: "0",
                      color: "#000",
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    {selectedProfile?.first_name && selectedProfile?.last_name
                      ? `${selectedProfile.first_name} ${selectedProfile.last_name}`
                      : selectedProfile?.first_name || ""}{" "}
                  </h2>
                  <br />

                  <button
                    onClick={() => setPopupOpen(false)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#999",
                      cursor: "pointer",
                      padding: "8px",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "top",
                      justifyContent: "top",
                    }}
                  >
                    <IonIcon icon={closeOutline} style={{ fontSize: "24px" }} />
                  </button>
                </div>
                <p className=" flex text-xl text-center items-center justify-center font-Figtree">
                  {requestTitle(selectedProfile)}
                </p>
                <small
                  className="text-gray-500"
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {(() => {
                    const now = new Date();
                    // Parse created_at as local time if no timezone, otherwise as UTC
                    const created = new Date(selectedProfile?.created_at);
                    const diff = Math.floor(
                      (now.getTime() - created.getTime()) / 1000,
                    );
                    if (diff < 60) return "just now";
                    if (diff < 3600)
                      return `${Math.floor(diff / 60)} minutes ago`;
                    if (diff < 86400)
                      return `${Math.floor(diff / 3600)} hours ago`;
                    return `${Math.floor(diff / 86400)} days ago`;
                  })()}
                </small>
                <div className=" flex text-xl text-center  mb-6  items-center justify-center">
                  {selectedProfile?.email || ""}
                  <br />
                  {selectedProfile?.phone || ""}
                </div>
                {/* Message and simple action (replaces dynamic/undefined button rendering) */}
                <div style={{ padding: "0 16px 16px" }}>
                  <div
                    style={{
                      padding: "0 ",
                      display: "flex",
                      gap: 12,
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <IonButton
                      expand="block"
                      fill={"solid"}
                      onClick={() => {
                        const action = async (selectedProfile: any) => {
                          setPopupOpen(false);
                          await confirmAcceptRequest(selectedProfile);
                        };
                        action(selectedProfile);
                      }}
                      className={"primary-button !w-[275px]"}
                      style={{
                        "--border-radius": "30px",
                        fontSize: "18px",
                        fontWeight: "500",
                      }}
                    >
                      {" "}
                      Accept{" "}
                    </IonButton>

                    <IonButton
                      expand="block"
                      fill={"outline"}
                      onClick={() => {
                        const action = async (selectedProfile: any) => {
                          setPopupOpen(false);
                          await confirmRejectRequest(selectedProfile);
                        };
                        action(selectedProfile);
                      }}
                      className={"tertiary-button !w-[275px]"}
                      style={{
                        "--border-radius": "30px",
                        fontSize: "18px",
                        fontWeight: "500",
                        "--color": "#ffffff !important",
                        borderRadius: "30px",
                      }}
                    >
                      Reject
                    </IonButton>
                  </div>
                </div>
              </div>
            </IonModal>
          )}{" "}
          {filteredRequests.length > 0 && (
            <div>
              <div className="flex items-center ">
                <p className="sub-section-title">Pending Requests</p>
              </div>
              <div
                className=" "
                style={{
                  overflowY: "auto",
                  maxHeight: "100%",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                {filteredRequests.length > 0 && (
                  <div className="rounded-xl bg-white shadow-sm overflow-hidden sm:mx-0 border">
                    {pendingOpen && (
                      <div
                        id="pending-requests-list"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {filteredRequests.map((request) => (
                          <div key={`incoming-${request.id}`} className="p-1">
                            <div className="flex items-center justify-between p-2">
                              <div className="flex items-center">
                                <div
                                  className="w-10 h-10 rounded-full bg-[#007C9E]    text-white flex items-center justify-center font-bold"
                                  onClick={() => {
                                    setSelectedProfile(request);
                                    setPopupOpen(true);
                                  }}
                                >
                                  {getInitials(request.profile?.first_name, request.profile?.last_name)}
                                </div>
                                <span
                                  className="ml-3 font-medium truncate"
                                  style={{ maxWidth: "120px" }}
                                  onClick={() => {
                                    console.log("Selected profile:", request);
                                    setSelectedProfile(request);
                                    setPopupOpen(true);
                                  }}
                                >
                                  {getUserName(request.profile)}
                                </span>
                              </div>
                              <div className="flex items-center cursor-pointer text-[#0778CF]">
                                <p
                                  className="px-1 py-1"
                                  style={{
                                    fontFamily: "Figtree, sans-serif",
                                    fontWeight: 500,
                                    fontStyle: "normal",
                                    fontSize: "13px",
                                    lineHeight: "22px",
                                  }}
                                  onClick={() => confirmAcceptRequest(request)}
                                >
                                  Accept
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                {/* Bottom spacing */}
                <div className="pb-4" />
              </div>
            </div>
          )}
        </>
        <div className="flex items-center mb-2  justify-between">
          <div className="flex items-center space-x-2">
            <p className="sub-section-title">People I am following</p>
          </div>

          {following.length > 0 && (
            <button
              type="button"
              onClick={onInviteClick}
              className="flex items-center focus:outline-none bg-transparent border-none hover:opacity-75 transition-opacity"
              style={{ height: "24px", color: "#0778CF", cursor: "pointer" }}
              aria-label="Send follow request"
            >
              <IonIcon
                icon={add}
                slot="icon-only"
                style={{ color: "#0778CF", fontSize: "18px" }}
              />
              <span
                className="ml-1"
                style={{
                  color: "#0778CF",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                Send Request
              </span>
            </button>
          )}
        </div>
      </div>
      <div
        className="space-y-2 pb-6"
        style={{
          overflowY: "auto",
          maxHeight: "100%",
          minHeight: "200px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Pending Outgoing Requests Section */}
        {pendingOutgoing.length > 0 && (
          <div className="rounded-xl bg-white shadow-sm overflow-hidden sm:mx-0 border">
            {pendingOpen && (
              <div id="pending-requests-list" style={{ maxHeight: "100%" }}>
                {pendingOutgoing.map((request) => (
                  <div key={`outgoing-${request.id}`} className="p-1">
                    <div className="flex items-center justify-between p-2">
                      <div className="flex items-center">
                        <div className="w-10 h-10 rounded-full bg-[#007C9E]    text-white flex items-center justify-center font-bold">
                          {getInitials(request.profile?.first_name, request.profile?.last_name)}
                        </div>
                        <span
                          className="ml-3 font-medium truncate"
                          style={{ maxWidth: "120px" }}
                        >
                          {getUserName(request.profile)}
                        </span>
                      </div>
                      <div className="flex items-center cursor-pointer text-[#0778CF]">
                        <p
                          className="px-1 py-1"
                          style={{
                            fontFamily: "Figtree, sans-serif",
                            fontWeight: 500,
                            fontStyle: "normal",
                            fontSize: "13px",
                            lineHeight: "22px",
                          }}
                          onClick={() => onCancelRequest(request)}
                        >
                          Cancel Request
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Current Following Section */}
        {following.length > 0 ? (
          <div
            className="bg-white rounded-xl shadow-sm overflow-auto sm:mx-0"
            style={{
              // maxHeight: "300px",
              // minHeight: "100px",
              overflowY: "auto",
              width: "100%",
            }}
          >
            <div
              className="bg-white rounded-xl shadow-sm overflow-auto sm:mx-0"
              style={{
                // maxHeight: "300px",
                // minHeight: "100px",
                overflowY: "auto",
                width: "100%",
              }}
            >
              {following.map((person) => (
                <FollowerListItem
                  key={person.id}
                  follower={person}
                  onRemove={onRemoveFollowing as any}
                  itemType="following"
                  showStatus={true}
                />
              ))}
            </div>
          </div>
        ) : (
          <EmptyState
            title="Follow an Arc Connect user"
            description="Send a request to another person to view their therapy data."
            buttonText="Send Request"
            onButtonClick={onInviteClick}
            icon={sendOutline}
          />
        )}

        {/* {following.length === 0 && pendingOutgoing.length > 0 && !isLoading && (
        <div className="bg-white rounded-xl shadow-sm p-6 text-center">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">
            No Active Following
          </h3>
          <p className="text-gray-600 mb-4">
            Wait for your pending requests to be accepted or send new requests to follow others.
          </p>
          <button
            onClick={onInviteClick}
            className="px-6 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-colors"
          >
            Send New Request
          </button>
        </div>
      )} */}

        {isLoading && hasData && (
          <div className="flex justify-center py-4">
            <IonSpinner name="dots" color="medium" />
          </div>
        )}

        {/* Bottom spacing */}
        <div className="pb-4" />
      </div>
    </>
  );
};

export default FollowingList;
